var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.awards.length)?_c('awards-list',{staticClass:"gl-px-2",attrs:{"awards":_vm.awards,"can-award-emoji":_vm.hasAwardEmojiPermission,"current-user-id":_vm.currentUserId},on:{"award":function($event){return _vm.handleAward($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }